import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import {
  BASE_URL
} from '../../constant';

const NotFound = () => {


  return (



  <React.Fragment>

    <Helmet>
        <meta name="prerender-status-code" content="404"></meta>
    </Helmet>
    
    <Header />
    

   <div className='container'>
    <div class="row" style={{ padding: 10 }}>

      <div class="col-12 text-center">

          <div >

             <img src={BASE_URL + "assets/images/404v1_600x600.webp"} width="600" alt="404" title="404"/>

          </div>
          
          <h1>Sorry, the page you were looking for does not exist or has been moved. Click below to go to Home Page</h1>
          
          <br/>

          <Link to="/">Home</Link>

          <br/>
          
        </div>
      </div>
    </div>

    <Footer />
    </React.Fragment>
  )

};

export default NotFound;